export const config = {
  apiGateway: {
    NAME: process.env.REACT_APP_STYCH_API_NAME,
    URL: process.env.REACT_APP_STYCH_API_URL
  },
  apiKey: process.env.REACT_APP_STYCH_API_KEY,
  AWS_REGION: process.env.REACT_APP_STYCH_AWS_REGION
};

export const amplifyConfig = {
  API: {
    endpoints: [
      {
        name: config.apiGateway.NAME,
        endpoint: config.apiGateway.URL,
        region: config.AWS_REGION
      }
    ]
  }
};
